import React, { useState } from "react";
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";
import { Label } from "../../components/ui/label";
import { FaEye, FaEyeSlash } from "react-icons/fa6";
import { useFormik } from "formik";
import * as Yup from "yup";
import AuthService from "../../services/auth/auth";
import { useDispatch, useSelector } from "react-redux";
import {
  setIsLoading,
  setUser,
  setUserData,
} from "../../store/slices/userSlice";
import { resetChatState } from "../../store/slices/chatSlice";
import { replace, useNavigate } from "react-router";
import { toastError, toastSuccess } from "../../components/ToastNotification";
import Logo from "../../assets/images/Frame 2.svg";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleSubmit = async ({ email, password }) => {
    try {
      setLoading(true);
      dispatch(setIsLoading(true));
      const response = await AuthService?.login(email, password);
      console.log("response111", response);
      if (response) {
        // window.location.href = "/home";
        toastSuccess("login successfully!");
        localStorage.setItem("GuideproAI_user", response?.data?.token);
        dispatch(resetChatState());
        dispatch(setUserData(response?.data));
        dispatch(setUser({ ...response?.data?.data, tenantId: response?.data?.tenantId }));
        // ✅ Remove the login page from history
        // window.history.replaceState(null, null, "/home");
        navigate("/home", { replace: true });

        setLoading(false);
        // window.location.reload();
      }
    } catch (error) {
      toastError(error?.response?.data?.message);
    } finally {
      setLoading(false);
      setTimeout(() => {
        dispatch(setIsLoading(false));
      }, 1000);
    }
  };

  // Formik configuration
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email format")
        .required("Email is required"),
      password: Yup.string().required("Password is required"),
    }),

    onSubmit: handleSubmit,
  });

  return (
    <div className="bg-hero relative">
      <div
        className="border rounded-md border-white w-20 text-center py-1 absolute top-5 left-5 cursor-pointer hover:bg-white hover:text-black duration-200"
        onClick={() => navigate(-1, { replace: true })}
      >
        Back
      </div>
      <div className="flex items-center justify-center h-screen w-full max-tab:px-5">
        <div className="max-w-xl w-full overflow-hidden rounded-md border-input borders">
          <div className="flex min-h-full flex-col justify-center px-6 py-12 lg:px-8 w-full h-fit shadow-lg bg-white/30 before-shadow relative">
            <div className="sm:mx-auto sm:w-full sm:max-w-sm grid justify-center text-center">
              <div
                onClick={() => navigate("/")}
                className="cursor-pointer w-[100px] h-[100px] mx-auto flex justify-center items-center rounded-full overflow-hidden"
              >
                <img src={Logo} alt="" />
              </div>
              <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-white">
                Log in to your account
              </h2>
            </div>

            <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
              <form className="space-y-6" onSubmit={formik.handleSubmit}>
                <div className="grid w-full items-center gap-1.5">
                  <Label htmlFor="email">Email</Label>
                  <Input
                    type="email"
                    id="email"
                    placeholder="Enter Your Email"
                    name="email"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.email}
                  />
                  {formik.touched.email && formik.errors.email ? (
                    <div className="text-red-500">{formik.errors.email}</div>
                  ) : null}
                </div>

                <div className="grid w-full items-center gap-1.5">
                  <Label htmlFor="password">Password</Label>
                  <div className="relative">
                    <Input
                      type={showPassword ? "text" : "password"}
                      id="password"
                      placeholder="Enter Your Password"
                      name="password"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.password}
                    />
                    <div
                      className="absolute top-1/2 right-4 -translate-y-1/2 cursor-pointer"
                      onClick={togglePasswordVisibility}
                    >
                      {showPassword ? (
                        <FaEyeSlash className="text-gray-400" />
                      ) : (
                        <FaEye className="text-gray-400" />
                      )}
                    </div>
                  </div>

                  {formik.touched.password && formik.errors.password ? (
                    <div className="text-red-500">{formik.errors.password}</div>
                  ) : null}
                </div>

                <div className="mt-4">
                  {loading ? (
                    <Button
                      type="button"
                      disabled
                      className="w-full flex gap-2 bg-primary text-white text-base"
                    >
                      <span className="submit_loader"></span>
                    </Button>
                  ) : (
                    <Button
                      type="submit"
                      disabled={loading}
                      className="w-full flex gap-2 bg-primary hover:bg-btnHover text-white text-base"
                    >
                      Login
                    </Button>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
